(function () {
  const STYLE_ID = "up-promote-custom-override";

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = `
      .UpPromote-customer-referral-signup-form *:not(button) {
        color: #050505 !important;
      }
      .UpPromote-customer-referral-signup-form button,
      .UpPromote-customer-referral-signup-form .button {
        color: #fafafa !important;
      }
    `;
    document.head.appendChild(style);
  }

  if (document.querySelector(".UpPromote-customer-referral-signup-form")) {
    injectStyles();
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;

        const hasForm =
          node.classList?.contains("UpPromote-customer-referral-signup-form") ||
          node.querySelector?.(".UpPromote-customer-referral-signup-form");

        if (hasForm) {
          injectStyles();
          observer.disconnect();
          return;
        }
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();